import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListItemIcon, Menu, MenuItem } from '@material-ui/core';
// icons
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

function OptionsMenu({ anchorEl, handleClose, toggleEdit, toggleDelete }) {
  const { t } = useTranslation();
  return (
    <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
      <MenuItem onClick={toggleEdit}>
        <ListItemIcon>
          <EditIcon />
        </ListItemIcon>
        {t('Edit')}
      </MenuItem>
      <MenuItem onClick={toggleDelete}>
        <ListItemIcon>
          <DeleteIcon />
        </ListItemIcon>
        {t('Delete')}
      </MenuItem>
    </Menu>
  );
}

// const areEqual = (preProps, nextProps) => preProps.anchorEl === nextProps.anchorEl;

export default React.memo(OptionsMenu);
